type ResponsiveValue = string;

interface ResponsiveUtils {
    vmax: (px: number) => ResponsiveValue;
    vmin: (px: number) => ResponsiveValue;
    vw: (px: number) => ResponsiveValue;
    vh: (px: number) => ResponsiveValue;
}

// Или объект с типами
export const r: ResponsiveUtils = {
    vmax: (px: number) => `${(px / 1920) * 100}vmax`,
    vmin: (px: number) => `${(px / 1080) * 100}vmin`,
    vw: (px: number) => `${(px / 1920) * 100}vw`,
    vh: (px: number) => `${(px / 1080) * 100}vh`,
};
